import { LineItem } from 'shared/types/cart';
import { centsToDollars } from './priceHelpers';

export const getProductFromLineItem = (lineItem: LineItem) => {
  const { productKey, name, price, productType, count, variant } = lineItem;

  const productId =
    productType?.obj?.key === 'edx_course_entitlement'
      ? lineItem?.variant?.attributes?.['course-key']
      : productKey;
  return {
    product_id: productId,
    sku: variant.sku,
    name,
    price: centsToDollars(price),
    quantity: count,
    category: variant.attributes?.['primary-subject-area'] ?? null,
    url: variant.attributes?.['url-course'] ?? null,
    lob: variant.attributes?.lob ?? 'edx',
    image_url: variant.images?.[0] ?? null,
    brand: variant.attributes?.['brand-text'] ?? null,
    product_type: productType?.obj?.name ?? null,
  };
};

export const getProductsFromLineItems = (lineItems: LineItem[]) =>
  lineItems.map(getProductFromLineItem);
